import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_IdDdWaiverBhSupportQuarterlyRevRep = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_IdDdWaiverBhSupportQuarterlyRevRep' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Behavior Consultant:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Behavior Specialist:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Support Coordinator:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtBehaviorConsultant' name='txtBehaviorConsultant' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtBehaviorSpecialist' name='txtBehaviorSpecialist' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSupportCoordinator' name='txtSupportCoordinator' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Behavior Support Plan Approved:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtBehaviorSupport' name='txtBehaviorSupport' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe any changes in behavior, medication(include prescribing doctor) and/or diagnosis:</span>
                    <textarea id='txtOtherDescribe' name='txtOtherDescribe' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Explain reasons for changes:</span>
                    <textarea id='txtOtherExplain' name='txtOtherExplain' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Target Behaviors:</span>
                    <textarea id='txtOtherBehaviors' name='txtOtherBehaviors' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Locations of Behavior Support Plan implementation</span>
                </p>

                <p className='w-750'>
                    <input type='checkbox' name='chkLocations' id='chkLocations' className='add-only' value='Home' /> Home &nbsp;
                    <input type='checkbox' name='chkLocations1' id='chkLocations1' className='add-only' value='DayProgram' /> Day Program &nbsp;
                    <input type='checkbox' name='chkLocations2' id='chkLocations2' className='add-only' value='Community' /> Community &nbsp;
                    <input type='checkbox' name='chkLocations3' id='chkLocations3' className='add-only' value='PlaceEmployment' /> Place of Employment
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Behavior Support Plan structure</span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' name='chkSupportPlan' id='chkSupportPlan' className='add-only' value='Modeling' /> Modeling &nbsp;
                    <input type='checkbox' name='chkSupportPlan1' id='chkSupportPlan1' className='add-only' value='ReinforcementConsequences' /> Reinforcement/Consequences &nbsp;
                    <input type='checkbox' name='chkSupportPlan2' id='chkSupportPlan2' className='add-only' value='TrainingstaffFamily' /> Training for staff/family &nbsp;
                    <input type='checkbox' name='chkSupportPlan3' id='chkSupportPlan3' className='add-only' value='OneSupervision' /> One-on-one supervision &nbsp;
                    <br />
                    <input type='checkbox' name='chkSupportPlan4' id='chkSupportPlan4' className='add-only' value='RedirectionBlocking' />Redirection & blocking &nbsp;
                    <input type='checkbox' name='chkSupportPlan5' id='chkSupportPlan5' className='add-only' value='VerbalPrompting' />Verbal Prompting &nbsp;
                    <input type='checkbox' name='chkSupportPlan6' id='chkSupportPlan6' className='add-only' value='EnvironmentalAccommodations' />Environmental accommodations
                </p>
                <p className='w-750'>
                    <input type='checkbox' name='chkLocations22' id='chkLocations22' className='add-only' value='Other' /> Other:
                        <textarea id='txtOtherPlan' name='txtOtherPlan' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe baseline data or data collected for previous review as well as a narrative of the previous review:</span>
                    <textarea id='txtBaseline' name='txtBaseline' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Include a narrative of the current quarter's data.</span>
                    <textarea id='txtNarrative' name='txtNarrative' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Next Steps:</span>
                    <textarea id='txtNextSteps' name='txtNextSteps' className='add-only'></textarea>
                </p>


            </div>
        </form >

    )
}











